'use strict';

import DeviceFilesListTemplate from './deviceFilesList.html';

export default angular
  .module('main.devices.edit.components.deviceFilesList', [])

  .directive('deviceFilesList', function() {
    return {
      restrict: 'E',
      template: DeviceFilesListTemplate,
      scope: {
      },
      controller: ($scope,
                   $q,
                   utils,
                   EditDeviceDataProvider) => {
        $scope.dataProvider = EditDeviceDataProvider.instance;

        angular.extend($scope, {
          scaleImage: scaleImage,
          closeModal: closeModal
        });

        // Remove Image Modal
        $scope.$on('$destroy', () => {
          $('#image-modal').remove();
        });

        init();

        function init() {
          $scope.loading = true;

          $q.all([
            $scope.dataProvider.deviceFilesResource.init()
          ])
            .then(() => {
              initViewModel();
              $scope.loading = false;
            }, (err) => {
              $scope.loading = false;
              // utils.handleApiError(err);
            });
        }

        function initViewModel() {
          $scope.files = angular.copy($scope.dataProvider.deviceFilesResource.value);
        }

        function scaleImage(imageUrl) {
          $scope.selectedUrl = imageUrl;
          $('#image-modal').modal('show');
        }

        function closeModal() {
          $('#image-modal').modal('hide');
        }

      }
    };
  })

  .name;
